export const productsStore = (state: any) => Object.assign({}, state.products);
